import { ApiTenantProvider } from "@incendium/api";
import { MiddleEarthURL } from "config";
import { apiTenantProviderToSamlPathSegment } from "features/login/samlAuthStartUrl";
import { AuthResponse } from "Types/auth";

export interface SamlLoginUrlResponse {
  login_url: string;
}

/**
 * Middle Earth SSO Authentication Service
 */
export const middleEarthService = {
  /**
   * Authenticate user with email and password
   */
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await fetch(`${MiddleEarthURL}/user/auth`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error(`Login failed: ${response.statusText}`);
    }

    return response.json();
  },

  async getSamlLoginUrl(params: {
    email: string;
    redirect: string;
    provider?: ApiTenantProvider;
  }): Promise<SamlLoginUrlResponse> {
    const provider =
      params.provider ?? ApiTenantProvider.TENANT_PROVIDER_MICROSOFT;
    const segment = apiTenantProviderToSamlPathSegment(provider);
    const url = new URL(`${MiddleEarthURL}/user/auth/saml/${segment}/start`);
    url.searchParams.set("email", params.email.trim());
    url.searchParams.set("redirect", params.redirect);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`SAML start failed: ${response.statusText}`);
    }

    return response.json();
  },

  /**
   * Refresh authentication token
   */
  async refreshToken(refreshToken: string): Promise<AuthResponse> {
    const response = await fetch(`${MiddleEarthURL}/user/auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });

    if (!response.ok) {
      throw new Error(`Token refresh failed: ${response.statusText}`);
    }

    return response.json();
  },
};
